module.exports = "<div *ngIf=\"hasResult\" class=\"d-flex h-100 scale-chart-container\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessment-charts/scale-chart/scale-chart.component.html
// module id = ./src/app/assessment-charts/scale-chart/scale-chart.component.html
// module chunks = main